module.exports = __webpack_public_path__ + "img/lock_clock_opsz24B.672149ca.svg";